module.exports = __webpack_public_path__ + "static/media/roots.eae696b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/roots.svg
// module id = 366
// module chunks = 0